<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="600px"
      v-bind:body-style="{ height: '450px',position: 'relative',overflow: 'auto'}"
    >
    <!-- 表单 -->
    <div >
      <a-steps direction="vertical" :current="current">
        <a-step v-for="(item,index) in progressList" :key="index">
          <template #icon>
            <div class="custom-step-icon">
              {{index+1}}
            </div>
            
          </template>
          <template #title>
            <div style="float:left; display:inline">{{item.taskNode}}</div>
            <div style="font-size: 14px;">{{item.updateTime}}</div>
          </template>
          <template #description>
            <div style="display: flex;">
              <div v-for="(img,index1) in item.pictureList">
                  <img alt="example" style="height: 50px;max-width: 100%;margin-right: 15px;" :src="url+img.id" @click="handleImg(img.id)"/>
              </div>
            </div>
            <div>{{item.taskInfo}}</div>

            <!-- 放大图片 -->
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelImg" class="imgBox" >
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </template>
        </a-step>
      </a-steps>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button class="cancel-color" ghost @click="handleCancel">取消</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import{ queryProgress } from "@/api/api.js";
export default {
  props: {
    modalTitle: {
      type: String,
      default: () => "",
    }, //标题
    data: {
      type: Object,
      default: () => [],
    },//返回信息
  },
  data() {
    return {
      visible: true,
      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },
      okLoad: false,
      progressList:[],//服务进度信息
      current:1,
      previewVisible: false,
      previewImage:process.env.VUE_APP_PROXY + "base/file/download-file?id=",
      url:process.env.VUE_APP_PROXY + "base/file/download-file?id=",
    }
  },
  mounted() {
    queryProgress({recNo: this.data.recNo}).then(
      (res) => {
        if (res.code == '0000') {
          this.progressList = res.content;
          this.current = this.progressList.length;
          console.log("111111",this.current);
        }
      },
      (err) => {
        this.$message.error('查询服务进度信息失败')
      }
    )
},
  methods: {
    
    /* 表格图片查看 */
    handleImg(file) {
      console.log("111111");
      this.previewVisible = true;
      this.bigurl = process.env.VUE_APP_PROXY + "base/file/download-file?id=";
      this.previewImage = this.bigurl + file;
    },
    /* 表格图片关闭 */
    handleCancelImg() {
      this.previewVisible = false;
    },
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

  },
}
</script>

<style lang="less" scoped>
.btn-color {
    background: rgba(22, 130, 139, 1);
    border-color: rgba(22, 130, 139, 1);
    margin-right: 10px;
    color: white;
}
.cancel-color{
  border-color: rgba(22, 130, 139, 1);
  color: rgba(22, 130, 139, 1);
}
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}
/deep/ .ant-steps-vertical .ant-steps-item-title {
    width: 90%;
    display: flex;
    justify-content: space-between;
}
/deep/ .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: rgba(22, 130, 139, 1);
}
.custom-step-icon{
  width: 32px;
    height: 32px;
    margin-right: 8px;
    font-size: 20px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    line-height: 28px;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.25);
    transition: background-color 0.3s, border-color 0.3s;
    border-radius: 32px;
    background: rgba(22, 130, 139, 1);
    color: white;
}
</style>
